import React, { useEffect } from 'react';
import { useHistory } from 'react-router';

import { Grid } from '@mui/material';

import PlatesList from '@shared/components/PlatesList';
import FormSearchHotel from '@shared/pages/Hotels/FormSearchHotel';
import { HOTELS_SEARCH } from '@shared/helpers/routes';
import TabsHeader from '@shared/components/TabsHeader';

import ImageSlider from '@shared/components/ImageSlider';

import { useSelector } from 'react-redux';

export default () => {
  const history = useHistory();
  const { business_types } = useSelector(store => store.pageConfiguration);

  const setIsReadyToNavigate = v => {
    if (v) history.push(HOTELS_SEARCH);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const typePlate = 1;

  return (
    <>
      <TabsHeader site={typePlate} />
      <FormSearchHotel
        needsNavigate={true}
        isHomePage={true}
        setReady={value => setIsReadyToNavigate(value)}
      />
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        direction="column"
        className="minWebPadding"
        style={{ backgroundColor: '#F2F2F2', paddingBottom: '50px' }}
      >
        <ImageSlider />
        <PlatesList
          title={
            business_types.code == 'BTC'
              ? 'Principales Destinos'
              : 'Alojamientos'
          }
          IdServiceType={2}
          typePlate={typePlate}
        />

        {business_types.code == 'BTC' && (
          <PlatesList
            title="Propuestas Irresistibles"
            IdServiceType={4}
            section={'irresistible-packages'}
            typePlate={2}
          />
        )}
      </Grid>
    </>
  );
};
